import { useState, useRef, useEffect } from "react";
import { BRAND, GradText, Section } from "../brand";

const PILLARS = [
  {
    title: "Revenue automation",
    hero: "+30%",
    heroLabel: "catering bookings",
    bullets: [
      "Catering & private events booked instantly via SMS",
      "Reservations confirmed with zero hold time",
      "Takeout captured 24/7 — peak service or 2am",
    ],
  },
  {
    title: "Operational efficiency",
    hero: "120 hrs",
    heroLabel: "saved monthly",
    bullets: [
      "Phone off the host stand",
      "No callback queues, no missed messages",
      "Friday-night chaos stops hitting service",
    ],
  },
  {
    title: "Buying back time",
    hero: "24/7",
    heroLabel: "coverage",
    bullets: [
      "Sundays, holidays, and late nights covered",
      "30% of calls land after-hours — now fully captured",
      "Multilingual line — Spanish guests no longer hang up",
    ],
  },
  {
    title: "Data & reporting",
    hero: "100%",
    heroLabel: "calls tagged",
    bullets: [
      "Transcripts + intent tags (reservation, catering, FAQ, complaint)",
      "GM and ops dashboards — who called, when, what they wanted",
      "Trend signals — language splits, peak-hour spikes",
    ],
  },
];

export default function DemandSlide({ isMobile }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <Section innerRef={ref} style={{ background: BRAND.white }}>
      <div style={{ maxWidth: 880, margin: "0 auto", width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 28 : 40 }}>
          <div
            style={{
              fontSize: 13,
              letterSpacing: 3,
              color: BRAND.orange,
              textTransform: "uppercase",
              fontWeight: 600,
              marginBottom: 12,
            }}
          >
            The opportunity
          </div>
          <h2
            style={{
              fontSize: isMobile ? 28 : 44,
              fontWeight: 800,
              color: BRAND.dark,
              margin: 0,
              lineHeight: 1.1,
              fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
            }}
          >
            What if you captured{" "}
            <GradText
              style={{
                fontSize: isMobile ? 28 : 44,
                fontWeight: 800,
                fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
              }}
            >
              100% of your demand?
            </GradText>
          </h2>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
            gap: 16,
          }}
        >
          {PILLARS.map((p, i) => (
            <div
              key={i}
              style={{
                background: BRAND.white,
                borderRadius: 20,
                padding: isMobile ? "26px 22px" : "32px 28px",
                border: "1px solid #EEF2F6",
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(20px)",
                transition: `all 0.6s cubic-bezier(0.16,1,0.3,1) ${i * 0.12}s`,
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: 2,
                  color: BRAND.orange,
                  textTransform: "uppercase",
                  fontWeight: 700,
                  marginBottom: 10,
                }}
              >
                {p.title}
              </div>
              <div
                style={{
                  fontSize: isMobile ? 44 : 56,
                  fontWeight: 800,
                  lineHeight: 1,
                  background: BRAND.gradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
                }}
              >
                {p.hero}
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "#64748B",
                  marginTop: 6,
                  fontWeight: 500,
                }}
              >
                {p.heroLabel}
              </div>
              <div
                style={{
                  height: 1,
                  background: "#EEF2F6",
                  margin: "20px 0 18px",
                }}
              />
              <ul
                style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                }}
              >
                {p.bullets.map((b, j) => (
                  <li
                    key={j}
                    style={{
                      fontSize: 14,
                      color: "#475569",
                      lineHeight: 1.6,
                      marginBottom: j < p.bullets.length - 1 ? 8 : 0,
                      paddingLeft: 22,
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        color: BRAND.orange,
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </span>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
